!function(t) {
    t.fn.extend({
        easyResponsiveTabs: function(e) {
            var a = e = t.extend({
                type: "default",
                width: "auto",
                fit: !0,
                closed: !1,
                tabidentify: "",
                activetab_bg: "white",
                inactive_bg: "#F5F5F5",
                active_border_color: "#c1c1c1",
                active_content_border_color: "#c1c1c1",
                activate: function() {}
            }, e)
              , i = a.type
              , n = a.fit
              , o = a.width
              , r = "vertical"
              , s = "accordion"
              , c = window.location.hash
              , d = !(!window.history || !history.replaceState);
            t(".template-featured-product").length && (d = !1),
            t(this).bind("tabactivate", function(t, a) {
                "function" == typeof e.activate && e.activate.call(a, t)
            }),
            this.each(function() {
                var a, l = t(this), p = l.find("ul.resp-tabs-list." + e.tabidentify), b = l.attr("id");
                l.find("ul.resp-tabs-list." + e.tabidentify + " li").addClass("resp-tab-item").addClass(e.tabidentify),
                l.css({
                    display: "block",
                    width: o
                }),
                "vertical" == e.type && p.css("margin-top", "3px"),
                l.find(".resp-tabs-container." + e.tabidentify).css("border-color", e.active_content_border_color),
                l.find(".resp-tabs-container." + e.tabidentify + " > div").addClass("resp-tab-content").addClass(e.tabidentify),
                function() {
                    i == r && l.addClass("resp-vtabs").addClass(e.tabidentify);
                    1 == n && l.css({
                        width: "100%",
                        margin: "0px"
                    });
                    i == s && (l.addClass("resp-easy-accordion").addClass(e.tabidentify),
                    l.find(".resp-tabs-list").css("display", "none"))
                }(),
                l.find(".resp-tab-content." + e.tabidentify).before("<h2 class='resp-accordion " + e.tabidentify + "' role='tab'><span class='resp-arrow'></span></h2>"),
                l.find(".resp-tab-content." + e.tabidentify).prev("h2").css({
                    "background-color": e.inactive_bg,
                    "border-color": e.active_border_color
                });
                var f = 0;
                l.find(".resp-accordion").each(function() {
                    a = t(this);
                    var i = l.find(".resp-tab-item:eq(" + f + ")")
                      , n = l.find(".resp-accordion:eq(" + f + ")");
                    n.append(i.html()),
                    n.data(i.data()),
                    a.attr("aria-controls", e.tabidentify + "_tab_item-" + f),
                    f++
                });
                var h = 0;
                l.find(".resp-tab-item").each(function() {
                    $tabItem = t(this),
                    $tabItem.attr("aria-controls", e.tabidentify + "_tab_item-" + h),
                    $tabItem.attr("role", "tab"),
                    $tabItem.css({
                        "background-color": e.inactive_bg,
                        "border-color": "none"
                    });
                    var a = 0;
                    l.find(".resp-tab-content." + e.tabidentify).each(function() {
                        t(this).attr("aria-labelledby", e.tabidentify + "_tab_item-" + a).css({
                            "border-color": e.active_border_color
                        }),
                        a++
                    }),
                    h++
                });
                var u = 0;
                if ("" != c) {
                    var v = c.match(new RegExp(b + "([0-9]+)"));
                    null !== v && 2 === v.length && (u = parseInt(v[1], 10) - 1) > h && (u = 0)
                }
                t(l.find(".resp-tab-item." + e.tabidentify)[u]).addClass("resp-tab-active").css({
                    "background-color": e.activetab_bg,
                    "border-color": e.active_border_color
                }),
                !0 === e.closed || "accordion" === e.closed && !p.is(":visible") || "tabs" === e.closed && p.is(":visible") || (t(l.find(".resp-accordion." + e.tabidentify)[u]).addClass("resp-tab-active").css({
                    "background-color": e.activetab_bg + " !important",
                    "border-color": e.active_border_color,
                    background: "none"
                }),
                t(l.find(".resp-tab-content." + e.tabidentify)[u]).addClass("resp-tab-content-active").addClass(e.tabidentify).attr("style", "display:block")),
                l.find("[role=tab]").each(function() {
                    t(this).click(function() {
                        var a = t(this)
                          , i = a.attr("aria-controls");
                        if (a.hasClass("resp-accordion") && a.hasClass("resp-tab-active"))
                            return l.find(".resp-tab-content-active." + e.tabidentify).slideUp("", function() {
                                t(this).addClass("resp-accordion-closed")
                            }),
                            a.removeClass("resp-tab-active").css({
                                "background-color": e.inactive_bg,
                                "border-color": "none"
                            }),
                            !1;
                        if (!a.hasClass("resp-tab-active") && a.hasClass("resp-accordion") ? (l.find(".resp-tab-active." + e.tabidentify).removeClass("resp-tab-active").css({
                            "background-color": e.inactive_bg,
                            "border-color": "none"
                        }),
                        l.find(".resp-tab-content-active." + e.tabidentify).slideUp().removeClass("resp-tab-content-active resp-accordion-closed"),
                        l.find("[aria-controls=" + i + "]").addClass("resp-tab-active").css({
                            "background-color": e.activetab_bg,
                            "border-color": e.active_border_color
                        }),
                        l.find(".resp-tab-content[aria-labelledby = " + i + "]." + e.tabidentify).slideDown().addClass("resp-tab-content-active")) : (console.log("here"),
                        l.find(".resp-tab-active." + e.tabidentify).removeClass("resp-tab-active").css({
                            "background-color": e.inactive_bg,
                            "border-color": "none"
                        }),
                        l.find(".resp-tab-content-active." + e.tabidentify).removeAttr("style").removeClass("resp-tab-content-active").removeClass("resp-accordion-closed"),
                        l.find("[aria-controls=" + i + "]").addClass("resp-tab-active").css({
                            "background-color": e.activetab_bg,
                            "border-color": e.active_border_color
                        }),
                        l.find(".resp-tab-content[aria-labelledby = " + i + "]." + e.tabidentify).addClass("resp-tab-content-active").attr("style", "display:block")),
                        d) {
                            var n = window.location.hash
                              , o = (i.split("tab_item-"),
                            l.find("ul.resp-tabs-list li.resp-tab-active").attr("id"));
                            if ("" != n) {
                                var r = l.find("ul.resp-tabs-list li.resp-tab-active").attr("id");
                                o = null != n.match(r) ? n.replace(r, o) : "#tab=" + o
                            } else
                                o = "#tab=" + o;
                            history.replaceState(null, null, o)
                        }
                        a.trigger("tabactivate", a)
                    })
                }),
                t(window).resize(function() {
                    l.find(".resp-accordion-closed").removeAttr("style")
                })
            })
        }
    })
}(jQuery),
function(t) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], t) : "undefined" != typeof module && module.exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function(t) {
    var e = -1
      , a = -1
      , i = function(t) {
        return parseFloat(t) || 0
    }
      , n = function(e) {
        var a = null
          , n = [];
        return t(e).each(function() {
            var e = t(this)
              , o = e.offset().top - i(e.css("margin-top"))
              , r = n.length > 0 ? n[n.length - 1] : null;
            null === r ? n.push(e) : Math.floor(Math.abs(a - o)) <= 1 ? n[n.length - 1] = r.add(e) : n.push(e),
            a = o
        }),
        n
    }
      , o = function(e) {
        var a = {
            byRow: !0,
            property: "height",
            target: null,
            remove: !1
        };
        return "object" == typeof e ? t.extend(a, e) : ("boolean" == typeof e ? a.byRow = e : "remove" === e && (a.remove = !0),
        a)
    }
      , r = t.fn.matchHeight = function(e) {
        var a = o(e);
        if (a.remove) {
            var i = this;
            return this.css(a.property, ""),
            t.each(r._groups, function(t, e) {
                e.elements = e.elements.not(i)
            }),
            this
        }
        return this.length <= 1 && !a.target ? this : (r._groups.push({
            elements: this,
            options: a
        }),
        r._apply(this, a),
        this)
    }
    ;
    r.version = "master",
    r._groups = [],
    r._throttle = 80,
    r._maintainScroll = !0,
    r._beforeUpdate = null,
    r._afterUpdate = null,
    r._rows = n,
    r._parse = i,
    r._parseOptions = o,
    r._apply = function(e, a) {
        var s = o(a)
          , c = t(e)
          , d = [c]
          , l = t(window).scrollTop()
          , p = t("html").outerHeight(!0)
          , b = c.parents().filter(":hidden");
        return b.each(function() {
            var e = t(this);
            e.data("style-cache", e.attr("style"))
        }),
        b.css("display", "block"),
        s.byRow && !s.target && (c.each(function() {
            var e = t(this)
              , a = e.css("display");
            "inline-block" !== a && "flex" !== a && "inline-flex" !== a && (a = "block"),
            e.data("style-cache", e.attr("style")),
            e.css({
                display: a,
                "padding-top": "0",
                "padding-bottom": "0",
                "margin-top": "0",
                "margin-bottom": "0",
                "border-top-width": "0",
                "border-bottom-width": "0",
                height: "100px",
                overflow: "hidden"
            })
        }),
        d = n(c),
        c.each(function() {
            var e = t(this);
            e.attr("style", e.data("style-cache") || "")
        })),
        t.each(d, function(e, a) {
            var n = t(a)
              , o = 0;
            if (s.target)
                o = s.target.outerHeight(!1);
            else {
                if (s.byRow && n.length <= 1)
                    return void n.css(s.property, "");
                n.each(function() {
                    var e = t(this)
                      , a = e.attr("style")
                      , i = e.css("display");
                    "inline-block" !== i && "flex" !== i && "inline-flex" !== i && (i = "block");
                    var n = {
                        display: i
                    };
                    n[s.property] = "",
                    e.css(n),
                    e.outerHeight(!1) > o && (o = e.outerHeight(!1)),
                    a ? e.attr("style", a) : e.css("display", "")
                })
            }
            n.each(function() {
                var e = t(this)
                  , a = 0;
                s.target && e.is(s.target) || ("border-box" !== e.css("box-sizing") && (a += i(e.css("border-top-width")) + i(e.css("border-bottom-width")),
                a += i(e.css("padding-top")) + i(e.css("padding-bottom"))),
                e.css(s.property, o - a + "px"))
            })
        }),
        b.each(function() {
            var e = t(this);
            e.attr("style", e.data("style-cache") || null)
        }),
        r._maintainScroll && t(window).scrollTop(l / p * t("html").outerHeight(!0)),
        this
    }
    ,
    r._applyDataApi = function() {
        var e = {};
        t("[data-match-height], [data-mh]").each(function() {
            var a = t(this)
              , i = a.attr("data-mh") || a.attr("data-match-height");
            e[i] = i in e ? e[i].add(a) : a
        }),
        t.each(e, function() {
            this.matchHeight(!0)
        })
    }
    ;
    var s = function(e) {
        r._beforeUpdate && r._beforeUpdate(e, r._groups),
        t.each(r._groups, function(t) {
            var e = this
              , a = 0;
            e.elements.length && setTimeout(function() {
                r._apply(e.elements, e.options)
            }, a += 500)
        }),
        r._afterUpdate && r._afterUpdate(e, r._groups)
    };
    r._update = function(i, n) {
        if (n && "resize" === n.type) {
            var o = t(window).width();
            if (o === e)
                return;
            e = o
        }
        i ? -1 === a && (a = setTimeout(function() {
            s(n),
            a = -1
        }, r._throttle)) : s(n)
    }
    ,
    t(r._applyDataApi),
    t(window).bind("load", function(t) {
        r._update(!1, t)
    }),
    t(window).bind("resize orientationchange", function(t) {
        r._update(!0, t)
    })
});
var handleizeStr = function(t) {
    return t.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
};
function blogSwiper() {
    var e = "featured-blog";
    var t = 15;
    if(typeof window.Swiper != "undefined"){
    new window.Swiper("#inline-swiper-" + e,{
        direction: "horizontal",
        pagination: {
            el: "#swiper-pagination-" + e,
            clickable: !0
        },
        loop: !1,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: t,
        simulateTouch: !0,
        breakpoints: {
            768: {
                slidesPerView: 4,
                slidesPerGroup: 1,
                spaceBetween: 15
            }
        },
        autoplay: !0
    })
    }
}
$(document).ready(function() {
    if ($(".quick-view-btn").length) {
        !function() {
            if ("function" == typeof $().magnificPopup) {
                var t = $("a.quick-view-btn");
                t.length && t.each(function() {
                    $(this).data("product-id"),
                    $(this).attr("data-product-id"),
                    $(this).attr("data-slider-type"),
                    $(this).data("url"),
                    $(this);
                    var t = window.location.pathname
                      , e = !1;
                    $(this).magnificPopup({
                        type: "ajax",
                        closeOnContentClick: !1,
                        mainClass: "mfp-move-from-top",
                        removalDelay: 1e3,
                        callbacks: {
                            elementParse: function(t) {
                                -1 == t.src.indexOf("nav-shopping-cart-dialog") && (t.src = t.src.split("?")[0] + "?view=quickview")
                            },
                            ajaxContentAdded: function() {
                                var t = $.magnificPopup.instance.st.el
                                  , a = ($(t).attr("href"),
                                $(".mfp-move-from-top").find(".shopify-section.product-section"));
                                if (!e) {
                                    var i = a.find("script");
                                    i.length && (i.each(function() {
                                        var t = $(this).attr("src")
                                          , e = ($(this).attr("id"),
                                        $(this).attr("type"))
                                          , a = $(this).html();
                                        if (document.getElementsByTagName("head")[0],
                                        "module" == e && t) {
                                            $('script[src="' + t + '"]').remove();
                                            var i = document.createElement("script");
                                            i.src = t,
                                            i.innerHTML = a,
                                            i.type = e,
                                            document.head.appendChild(i)
                                        }
                                    }),
                                    e = !0)
                                }
                                a.length && a.addClass("shopify-section--reveal")
                            },
                            close: function() {
                                window.history.pushState({}, document.title, t)
                            }
                        }
                    })
                })
            }
        }()
    }
    var t = $(".product-description-tabs");
    if (t.length) {
        var e = t.attr("data-sectionId")
          , a = t.html();
        if (void 0 !== a) {
            var i = a;
            if (null !== i && i.length > 1) {
                $(".product-description-tabs-" + e).html('<ul class="resp-tabs-list pr-tab-' + e + '"></ul><div class="resp-tabs-container pr-tab-' + e + '"></div>');
                var n = i.split("<h4>");
                if ($.each(n, function(t, a) {
                    0 != t && (info = a.split("</h4>"),
                    $(".resp-tabs-list.pr-tab-" + e).append('<li id="' + handleizeStr(info[0]) + '">' + info[0] + "</li>"),
                    $(".resp-tabs-container.pr-tab-" + e).append("<div>" + info[1] + "</div>"))
                }),
                $(".product-description-tabs-" + e).easyResponsiveTabs({
                    type: "default",
                    width: "auto",
                    fit: !0,
                    tabidentify: "pr-tab-" + e,
                    activate: function() {
                        $.fn.matchHeight._maintainScroll = !0,
                        $.fn.matchHeight._update()
                    }
                }),
                "" !== window.location.hash) {
                    var o = "#" + window.location.hash.split("#tab=")[1];
                    $(".product-description-tabs-" + e).find(o).click()
                }
            }
        }
    }
    $("[rel=popover]").popover()
}),
window.addEventListener("load", function(t) {
    blogSwiper()
});
